import React from "react";
import { Send, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { useContactForm } from "../hooks/useContactForm";
import { ContactIdentityFields, ContactMatterFields, HoneypotField } from "./ContactFields";

export default function ContactForm() {
  const { form, update, set, submit, submitting, practiceAreas } = useContactForm();

  return (
    <div className="bg-white text-[#1a2c4e] p-8 md:p-10" data-testid="contact-form-container">
      <h3 className="font-serif text-3xl mb-2">Send Us a Message</h3>
      <p className="text-[#4a6d8c] text-sm mb-6">We typically respond within one business day.</p>
      <form onSubmit={submit} className="space-y-4">
        <ContactIdentityFields form={form} update={update} />
        <ContactMatterFields form={form} set={set} update={update} practiceAreas={practiceAreas} />
        <HoneypotField value={form.website} onChange={update("website")} />
        <Button type="submit" disabled={submitting} data-testid="contact-submit-button" className="btn-primary rounded-none h-12 px-8 w-full sm:w-auto uppercase tracking-widest text-xs">
          {submitting ? (
            <>Sending <Loader2 className="w-4 h-4 ml-2 animate-spin" /></>
          ) : (
            <>Send Inquiry <Send className="w-4 h-4 ml-2" /></>
          )}
        </Button>
        <p className="text-xs text-[#4a6d8c] leading-relaxed pt-2">
          Submission of this form does not create an attorney-client relationship. Please do not include confidential information.
        </p>
      </form>
    </div>
  );
}
